import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Produto } from 'src/app/models/api/dados-produto/produto';
import { environment } from 'src/environments/environment';
import { ApiImportadorPlanilhaService } from 'src/app/services/api/importador/api-importador-planilha.service';
import { ApiDadosProdutosService } from 'src/app/services/api/dados-produto/api-dados-produtos.service';
import { EnumElasticDashboardColumns } from 'src/app/models/api/elastic/elastic-dashboard-columns.enum';
import { ApiHistoricoService } from 'src/app/services/api/historico/api-historico.service';
import { EnumProductTableInResponsableSubView, ProductTableInResponsable } from '../product-list.component';
import { SessionService } from 'src/app/services/session.service';
import { IPaginator } from 'src/app/ui/paginator/paginator.component';
import { WorkflowProduto } from 'src/app/models/api/workflow/workflow-produto.interface';
import { IResponse } from 'src/app/models/api/response.interface';
import { DashboardFornecedor } from 'src/app/models/api/dashboard-fornecedor/dashboard-fornecedor';
import { QueryFilter } from 'src/app/models/api/query/query-filter.interface';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';
import { DashboardService } from '../../services/dashboard.service';
import { ApiElasticDashboardService } from 'src/app/services/api/elastic/api-elastic-dashboard.service';
import { EnumTabStatus } from 'src/app/models/api/produto/enum-tab-status.enum';

@Component({
  selector: 'c-product-list-table-in-responsable',
  templateUrl: './product-list-table-in-responsable.component.html',
  styleUrls: ['./product-list-table-in-responsable.component.scss']
})
export class ProductListTableResponsableComponent implements OnInit {

  integrationDataSource = [];
  @Output() onPaginate = new EventEmitter<{
    paginator: IPaginator;
    status: EnumProductTableInResponsableSubView;
  }>();
  tabSelected: EnumProductTableInResponsableSubView =
    EnumProductTableInResponsableSubView.inRevision;
  EnumProductTableInResponsableSubView = EnumProductTableInResponsableSubView;
  defaultTableColumns: string[] = [
    "reference",
    "supplierCodSap",
    "supplierName",
    "description",
    "category",
    "quality",
    "createdAt",
    "createdAtCommercial",
    "registerResponsable",
    "commercialResponsable",
    "actions",
  ];
  inRevisionTabFilterPermission: string;
  tabs!: ProductTableInResponsable[];
  page$ = new BehaviorSubject<IPaginator>({
    isLastPage: false,
    page: 1,
    pageLength: 25,
    total: 0,
  });

  columnFilters$: BehaviorSubject<string[]>;

  isNotFornecedor = true;

  constructor(
    private elasticDashboardServ: ApiElasticDashboardService,
    private sessionService: SessionService,
    private dashboardService: DashboardService,
  ) {
    this.configureSearch();
  }

  async ngOnInit() {
    this.isNotFornecedor = this.sessionService.user.role !== 'fornecedor';
    this.createColumnFilters();
    this.createTabs();
    this.loadAllProductsData();
  }

  configureSearch() {
    this.dashboardService.search$.pipe(skip(1), debounceTime(800)).subscribe(() => {
      this.loadAllProductsData(true);
    });
  }

  createColumnFilters() {
    const columnValues: string[] = Object.keys(EnumElasticDashboardColumns).map(
      (key) => EnumElasticDashboardColumns[key]
    );

    this.columnFilters$ = new BehaviorSubject<string[]>(columnValues);
  }

  loadAllProductsData(isSearch: boolean = false) {
    for (const key of Object.keys(EnumProductTableInResponsableSubView)) {
      const status = Number(key);
      console.log({
        status,
        isNotFornecedor: this.isNotFornecedor,
        condicao2: this.isNotFornecedor && status === 0,
        condicaoTotal: this.isNotFornecedor || this.isNotFornecedor && status === 0
      })
      if (!isNaN(status)) {
        if (this.isNotFornecedor || !this.isNotFornecedor && status === 0) {
          this.loadProductsData(status, isSearch);
        }
      }
    }
  }

  loadProductsData(status: EnumProductTableInResponsableSubView, isSearch: boolean = false) {
    let api: any;
    const tab: ProductTableInResponsable = this.tabs.find(
      (elem) => elem.status == status
    );

    // Select api
    switch (status) {

      case EnumProductTableInResponsableSubView.inRevision:
        api = this.elasticDashboardServ.getResponsavelTodosEmRevisao;
        api = api.bind(this.elasticDashboardServ);
        break;

      case EnumProductTableInResponsableSubView.inOpen:
        api = this.elasticDashboardServ.getResponsavelTodosIntegrados;
        api = api.bind(this.elasticDashboardServ);
        break;

      case EnumProductTableInResponsableSubView.all:
        api = this.elasticDashboardServ.getTodosResponsavel;
        api = api.bind(this.elasticDashboardServ);
        break;

      default:
        break;
    }
    
    if (api) {
      const paginator = this.page$.value;

      api({
        query: this.dashboardService.search$.value,
        skip: isSearch ? 0 : (paginator.page - 1) * paginator.pageLength,
        take: paginator.pageLength,
        filteredColumns: this.columnFilters$.value,
        sortedColumns: tab ? tab.sort : undefined,
      } as QueryFilter).subscribe((res: any) => {
        this.createTabData(res, status);
      });
    }
  }

  private createTabData(
    data: IResponse<DashboardFornecedor[] | WorkflowProduto[]>,
    status: EnumProductTableInResponsableSubView,
    subViewType?: EnumProductTableInResponsableSubView
  ) {
    const tab = this.tabs.find((elem) => elem.status == status);

    if (tab) {
      tab.count = data.count || 0;
      tab.products = data.data || [];
      this.inRevisionTabFilterPermission =
        "rhcdm.dadosprodutos.listarIntegracoes";
    }
  }

  reload(paginator: IPaginator, status: EnumProductTableInResponsableSubView) {
    this.page$.next(paginator);
    this.loadProductsData(status);
  }

  updateSort(
    data: { [x: string]: number },
    paginator: IPaginator,
    status: EnumProductTableInResponsableSubView
  ) {
    const tab = this.tabs.find((elem) => {
      return elem.status == status;
    });

    tab.sort = data;
    this.reload(paginator, status);
  }

  private createTabs() {
    if(this.isNotFornecedor)
      this.tabs = [
        {
          name: "responsable",
          title: "Produtos em Revisão",
          status: EnumProductTableInResponsableSubView.inRevision,
          subViews: [],
          permission: "rhcdm.comercial.visualizarAba",
          count: 0,
          products: [],
        },
        {
          name: "responsable",
          title: "Produtos para Liberação",
          status: EnumProductTableInResponsableSubView.inOpen,
          subViews: [],
          permission: "rhcdm.comercial.visualizarAba",
          count: 0,
          products: [],
        },
        {
          name: "responsable",
          title: "Todos Produtos para Liberação",
          status: EnumProductTableInResponsableSubView.all,
          subViews: [],
          permission: "rhcdm.comercial.visualizarAba",
          count: 0,
          products: [],
        },
      ]
  }

}
